import { Controller } from '@hotwired/stimulus'

import {
  reportReloadLanded,
  trackReportEvent,
} from '@app/application/report/report-tracking'

// Mounted outside the table turbo-frame, so it connects once per full-page open
// rather than on every frame sub-request.
export default class extends Controller {
  connect(): void {
    // Turbo draws its cached copy of a page that was open before, then the
    // response, and this connects on both. The copy is not an open.
    if (document.documentElement.hasAttribute('data-turbo-preview')) return

    // Neither is the report reloading itself to show a set that was just saved.
    if (reportReloadLanded()) return

    trackReportEvent('Reports: Report Opened')
  }
}
